{
  "ACTIONS": {
    "CONFIRM": "Onayla",
    "CONTINUE": "Devam",
    "SUBMIT": "Gönder",
    "RETRY": "Tekrar dene",
    "CANCEL": "İptal Et",
    "EMPTY": "Hiçbir siparişiniz yok",
    "LOADING_ORDERS": "Faturanız hazırlanıyor",
    "CLEAR_ALL": "Clear All",
    "AWESOME": "Awesome!",
    "VIEW_RECEIPT": "The Receipt",
    "ADD_CART": "Add to Cart",
    "UPDATE_CART": "Sepeti Güncelle",
    "EDIT": "Düzenle",
    "SEARCH_PLACEHOLDER": "Search for food or restaurants"
  },
  "COMMON": {
    "CALORIES": "Cal. {{calories}}",
    "MISSING_SELECTIONS": "Some options are missing, please select before proceeding",
    "ITEM_UNAVAILABLE": "This item is currently not available",
    "SECTION_NOT_FOUND": "Bu bölüm artık mevcut değil",
    "ITEM_NOT_FOUND": "Bu ürün artık mevcut değil",
    "PROMOTION_NOT_AVAILABLE": "Bu promosyon artık mevcut değil",
    "REQUIRED": "Required",
    "COMBO": "Kombo",
    "INVALID_EMAIL": "Lütfen geçerli bir e-posta adresi girin",
    "INVALID_PHONE": "Lütfen geçerli bir telefon numarası girin",
    "FEES": "Fees",
    "MIN_ORDER_ERROR": "Minimum order value of {{currency}} {{amount}} is required to place your order",
    "ADD_MIN_ORDER": "Add {{currency}} {{amount}} to place your order",
    "CONNECTION_ERROR": "Bu masa yüklenirken bir sorun oluştu. Lütfen tekrar deneyin.",
    "TABLE_NOT_FOUND": "Bu masayı bulamadık. Lütfen QR kodunu tekrar tarayın."
  },
  "LANGUAGES": {
    "EN": "English",
    "AR": "عربي",
    "FA": "فارسي",
    "HI": "हिन्दी",
    "RU": "русский",
    "DE": "Deutsch",
    "FR": "Français",
    "TH": "ไทย",
    "EL": "Ελληνικά",
    "CNR": "Crnogorski",
    "ZH-HANS": "中文",
    "RO": "Română",
    "HU": "Magyar",
    "BG": "български",
    "TR": "Türkçe",
    "ES": "Español"
  },
  "BILL": {
    "NAME": "Soyadı",
    "ROOM_NUMBER": "Oda Numarası",
    "SNACKBAR_TITLE": "Faturanız yolda",
    "PAY_BILL": "Ödeme faturası"
  },
  "PAY_AT_TABLE": {
    "TOTAL_PEOPLE": "Masadaki toplam kişi sayısı",
    "PAYING_FOR": "Ödeme yaptığınız toplam kişi sayısı",
    "REMAINING": "Kalan tutar",
    "CHEQUE": "Hesap",
    "AMOUNT_PAID": "Ödenen tutar",
    "DISCOUNT": "İndirim",
    "PROMO": "Promosyon",
    "FEES": "Ücretler",
    "PAID_ITEMS": "Ödenen öğeler",
    "SPLIT_BILL": "Faturayı böl",
    "EDIT_SPLIT": "Bölmeyi düzenle",
    "PAY_BILL": "Faturayı öde",
    "SPLIT_TITLE": "Faturayı böl",
    "SPLIT_SUBTITLE": "Faturayı nasıl bölmek istediğinizi seçin",
    "SPLIT_EVENLY": "Eşit böl",
    "CUSTOM_AMOUNT": "Özel tutar",
    "ADD_CUSTOM_AMOUNT": "Özel tutar ekle",
    "CUSTOM_AMOUNT_PLACEHOLDER": "Özel tutar girin",
    "PAY_FOR_ITEMS": "Öğelerinizin ödemesini yapın",
    "CONFIRM_SELECTION": "Seçimi onayla",
    "SOMEONE_ELSE_PAYING": "Masanızdaki başka biri şu anda ödeme yapıyor"
  },
  "COMBO": {
    "ADD_N": "{{count}} {{section}} ekle",
    "REMOVE_N": "{{count}} {{section}} kaldır",
    "CANNOT_PROCEED": "Devam etmeden önce kombonuzu tamamlamak için lütfen yukarıdaki kılavuzu izleyin",
    "COMPLETE": "{{combo}} kombosu tamamlandı!",
    "ON_ANOTHER_SECTION": "Bu, {{section}} kombonuzun bir parçasıdır"
  },
  "CART": {
    "TITLE": "Sepet",
    "RECOMMENDATION": "Bunları da beğenebilirsiniz",
    "TOTAL": "Toplam",
    "VIEW": "Sepeti görüntüle & Sipariş ver",
    "EMPTY": "Boş",
    "PLACE_ORDER": "Sipariş ver",
    "ADD_TO_BILL": "Faturaya ekle",
    "PAY_NOW": "Şimdi öde",
    "OOPS": "Hata",
    "ADD_NEW_VARIANT": "Bir tane daha ekle",
    "VARIANT_TITLE": "Fikrinizi mi değiştirdiniz?",
    "ITEM_UPDATED": "An item in your cart has been updated",
    "ITEM_REMOVED": "An item was removed from your cart because it's no longer available",
    "ITEM_LINE": "{{name}}",
    "CONFIRM_CLEAR": "Are you sure you want to clear the cart?",
    "CLEAR": "Clear Cart",
    "ADD_NOTE": "ADD A NOTE",
    "NOTE_LABEL": "Note"
  },
  "PAYMENT": {
    "CONFIRMED": "Your order has been paid !",
    "ERROR": "An error occurred during payment, please try again",
    "APPLE_PAY_TAP_AGAIN": "Please tap Apple Pay again to continue",
    "TITLE": "Ödeme",
    "PAY_CARD": "Checkout",
    "SUCCESSFUL": "Payment Was Successful",
    "SUMMARY": "Payment Summary",
    "PROGRESS": "Payment in progress..., please wait",
    "CANCEL": "Please do not refresh this page or click on the back button. If you wish to cancel, please press the cancel button on the payment machine."
  },
  "ORDER": {
    "TITLE": "Siparişlerim",
    "CONFIRMED": "Confirmed",
    "NOTES": "Order Notes",
    "TOTAL": "Toplam",
    "SUBTOTAL": "Subtotal",
    "ORDER": "Sipariş",
    "PAID": "Paid",
    "PLACED": "Your Order Has Been Placed",
    "UNPAID": "Siparişiniz ödenmedi",
    "CANCELLED": "Siparişiniz iptal edildi",
    "VOID": "Siparişiniz geçersiz kılındı",
    "UPDATED": "Siparişiniz güncellendi",
    "ORDERS": "Orders",
    "PREVIOUS": "Previous Orders",
    "REJECTED": "Oops! One or more items or modifiers are currently unavailable and have been removed from your cart."
  },
  "WAITER": {
    "SNACKBAR_TITLE": "Biraz sonra yanınızda olacak",
    "HELP": "Nasıl yardımcı olabiliriz?",
    "ADDITIONAL_COMMENTS": "Comments"
  },
  "MENU": {
    "SKIP": "Atla",
    "MENU": "Menü",
    "SEARCH": "Ara",
    "NO_SEARCH_RESULTS": "Aramanızla eşleşen ürün bulunamadı",
    "SEARCH_OTHER_SECTIONS": "Diğer bölümlerde eşleşmeler bulduk",
    "NO_FILTER_RESULTS": "Filtrelerinize uyan ürün bulunamadı",
    "CLEAR_FILTERS": "Filtreleri temizle",
    "NO_SECTIONS": "Kullanılabilir bölüm yok",
    "STAFF": "Personeli ara",
    "FILTERS": "Dietery Filters"
  },
  "SETTINGS": {
    "TITLE": "Ayarlar",
    "LANGUAGE": "Dil",
    "SELECT_LANGUAGE": "Dil seçin",
    "CURRENCY": "Currency"
  },
  "HOTEL_PREFERENCE": {
    "ROOM": "Odama ücretlendir"
  },
  "RESCAN": {
    "TITLE": "QR",
    "ACTION": "Please rescan the QR to continue your session",
    "SESSION_EXPIRED": "Your session has expired"
  },
  "PICKUP": {
    "TITLE": "Your Details"
  },
  "VOUCHER": {
    "ADD": "Add a Voucher",
    "PLACEHOLDER": "Kuponunuzu girin",
    "VOUCHER": "Voucher",
    "DISCOUNTED_AMOUNT": "Total After Discount",
    "CURRENT_BALANCE": "Balance",
    "REMAINING_BALANCE": "Balance After Purchase",
    "AMOUNT_DUE": "Amount Due"
  },
  "TIP": {
    "TIP": "Bahşiş",
    "ADD": "Bahşiş ekle",
    "PLACEHOLDER": "Bahşiş tutarını girin"
  },
  "LANDING": {
    "CALL_WAITER": "Garsonu çağır",
    "VIEW_BILL": "Faturayı görüntüle - ",
    "LOADING_BILL": "Fatura yükleniyor"
  },
  "LOADER": {
    "Heading": "Ödemeniz işleniyor...",
    "Subheading": "Lütfen bu sayfayı kapatmayın. Ödemenizi onaylıyoruz ve sizi otomatik olarak yönlendireceğiz.",
    "Hint": "Bu genellikle birkaç saniye sürer."
  },
  "NoVoucher": "Kupon mevcut değil",
  "VoucherDisabled": "Bu kupon devre dışı",
  "VoucherExpired": "Bu kuponun süresi doldu",
  "VoucherAlreadyUsed": "Bu kupon zaten kullanıldı",
  "VoucherZeroBalance": "Bu kuponun bakiyesi 0",
  "VoucherUserLimitReached": "Bu kuponu zaten kullandınız",
  "VoucherFirstOrderOnly": "Bu kupon yalnızca ilk siparişiniz için geçerlidir",
  "VoucherNotApplicable": "Bu kupon siparişinizdeki ürünlere uygulanmıyor"
}
